import Request from './request'

const Client  = {
  getClients(callback) {
    Request.get('clients').then(callback).catch(this.bad_answer)
  },
  getCompanyUsers(callback) {
    Request.get('clients/company-users').then(callback).catch(this.bad_answer)
  },
  getClientList(callback) {
    Request.get('clients/list').then(callback).catch(this.bad_answer)
  },
  getClientInfo(client_id, callback) {
    Request.get('clients/' + client_id).then(callback).catch(this.bad_answer)
  },
  getClientGroups(client_id, callback) {
    Request.get('clients/' + client_id + '/groups').then(callback).catch(this.bad_answer)
  },
  getClientUsers(client_id, callback) {
    Request.get('clients/' + client_id + '/users').then(callback).catch(this.bad_answer)
  },
  updateClient(client_id, params, callback) {
    Request.put('clients/' + client_id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createClient(params, callback) {
    Request.post('clients', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Client
